import { landlineRegex, mobileRegex } from "../components/Variables";

export function shortDateString(datestring, separator) {
    if (datestring == null) return ""; 
    var d = new Date(datestring);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    var day = day_of_the_month(d);
    var month = months[d.getMonth()];
    return day + separator + month + separator + d.getFullYear();
}

export function IsEmpty(jsn) {
    return Object.keys(jsn).length === 0 && jsn.constructor === Object;
}

export function dateAndMonth(dateString, separator = " ") {
    if (dateString == null) return ""
    var d = new Date(dateString);
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var day = dateSuffix(d.getDate());
    var month = months[d.getMonth()];
    return day + separator + month + separator + d.getFullYear();
}

export function day_of_the_month(d) {
    return (d.getDate() < 10 ? '0' : '') + d.getDate();
}

export function TelephoneType(kind) {
    var telKind = ['', 'Unknown', 'Mobile', 'Home', 'Work'];
    return telKind[kind];
}

export function getPhonetype(string) {
    var type = 1;
    if (landlineRegex.test(string)) {
        type = 3;
    } else if (mobileRegex.test(string)) {     
        type = 2;
    }
    return type;
}

export function getPrimary(array) {
    if (Array.isArray(array)) {
        return array.filter((e) => e.primary === true);
    }
    return [];
}

export const monthName = ["Dec", "Nov", "Oct", "Sept", "Aug", "Jul", "Jun", "May", "Apr", "Mar", "Feb", "Jan"];

export function dateSuffix(i) {
    var j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}

export const transactionType = [
"Unknown",
"Payout",
"Payout Refund",
"Instalment due",
"Instalment due reversal",
"Accrued Interest",
"Interest Credit",
"Interest Debit",
"Principal Credit",
"Principal Debit",
"Card Payment",
"Card Cancel Payment",
"Card Refund Payment",
"Card Chargeback",
"RMI DD",
"RMI DD Bounce",
"RMI DDI",
"Payment Plan DD",
"Payment Plan DD Bounce",
"Payment Plan DDI",
"Auto GT DD",
"Auto GT DD Bounce",
"Auto GT DDI",
"Paypoint",
"Paypoint Reversal",
"Cheque",
"Cheque Refund",
"Cash Receipt Credit",
"Cash Receipt Debit",
"Balance Transfer Credit",
"Balance Transfer Debit",
"Write - off to bad debt",
"Court Balance Adjustment Credit",
"Court Balance Adjustment Debit",
"Court Costs",
"Court Costs Refund",
"Solicitor Fee",
"Solicitor Fee Refund"
]

export function ToDecmialPlace(amount) {
    if (amount == null) {
        return amount;
    }
    else {
        return amount.toFixed(2);
    }
}


// WEBPACK FOOTER //
// ./src/Functions/Generic.js